import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const gettingStartedTheme = createTheme({
  typography: {
    ...rootTheme.typography,
  },
});

export const theme = createTheme({});